<template>
  <div style="max-width: 600px">
    <div class="rounded-lg golden-border">
      <div class="border-gray-bottom d-flex justify-center">
        <h1 class="text-h4-center my-4 gold--text">אודות ה{{ about.title }}</h1>
      </div>
    </div>
    <div>
      <span class="center-all pa-10" v-text="about.description"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "about-page",
  props: {
    value: Boolean,
    type: { type: String, default: "app" },
  },
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
    about() {
      const type = this.$route.params.type ? this.$route.params.type : this.type
      return this.$store.getters.aboutByType(type) || {}
    },
  },
  async mounted() {
    if (!this.$store.getters.abouts.length) {
      await this.$store.dispatch("about/index")
    }
  },
}
</script>
<style lang="scss" scoped>
.golden-border {
  border: 2px solid var(--golden);
}
.border-gray-bottom {
  border-bottom: 1px solid var(--lightGrey);
}
</style>
